module.exports = __webpack_public_path__ + "static/media/carousel18.3bfd15e2.jpg";